
    <div class="modal-header">
      <h4 class="modal-title">
        <a><i id="close_login_modal_link" class="fa fa-times" (click)="cancel()"></i></a>
        <span translate>Login</span>
      </h4>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12">
          <p translate>eDuuni information</p>
          <p translate>Login information</p>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button id="login_modal_button" type="button" class="btn btn-action" (click)="login()" translate>Log In</button>
      <button id="register_login_modal_button" type="button" class="btn btn-action" (click)="register()" translate>Register</button>
    </div>
  